import React from 'react';
import WatchReview from '../watchReview'


function Baskin(props) {

        return (
            <WatchReview 
                tube="https://www.youtube.com/embed/hYtLUBTI_2M" 
                blerb="Welcome to Brothers Sip and Talk Shit, where we discuss all things horror and foreign...films. Over our next drink, we discuss 'Baskin'. A Turkish horror short turned feature about some police officers stumbling on an entrance to Hell..It may have been the best week to watch it..."
            />
        )
    }   

export default Baskin;